import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  useGetfixedPasswordOtp,
  useModifyPaymentFixedPassword,
} from "../../lib/queries/queriesAndMutations.js";
import { FixedPasswordSchema } from "../../lib/validation/index.js";
import CustomFormInput from "../../ui/CustomFormInput/index.js";
import PaymentButton from "../../ui/PaymentButton.jsx";
import Cookies from "js-cookie";
import { useEffect } from "react";

const ChangeFixedPassPage = () => {
  const navigate = useNavigate();

  const { mutateAsync: modifyPaymentFixedPassword, isPending } =
    useModifyPaymentFixedPassword();
  const { mutateAsync: getfixedPasswordOtp } = useGetfixedPasswordOtp();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: { otp: "", fixed_password: "" },
    resolver: zodResolver(FixedPasswordSchema),
  });

  const processForm = async (data) => {
    try {
      const response = await modifyPaymentFixedPassword(data);
      if (response.status === 201 || response.status === 200) {
        toast.success("رمز ثابت انتقال وجه با موفقیت تغییر یافت");
      }
    } catch (error) {
      console.error("ConfirmNewPasswordPage", error);
    }
  };

  useEffect(() => {
    getfixedPasswordOtp();
  }, []);

  return (
    <div className="figure-wrapper gap-4 h-full">
      <img
        src={"/icons/password-minimalistic.svg"}
        alt=""
        className=" mt-4 max-h-[200px]"
      ></img>

      <form
        onSubmit={handleSubmit(processForm)}
        className="flex flex-col gap-4 w-full max-w-[340px] mx-auto"
      >
        <p className="text-[#7f7f7f] text-[16px] mb-1  font-bold w-full  mt-8">
          جهت تغییر رمز ثابت انتقال وجه، فرم زیر را تکمیل و ارسال نمایید
        </p>
        <CustomFormInput
          tabIndex={"8"}
          control={control}
          name={"otp"}
          label={"پیامک ارسالی"}
          type={"text"}
          isPassword={true}
          errors={errors.otp}
        />
        <CustomFormInput
          tabIndex={"8"}
          control={control}
          name={"fixed_password"}
          label={"رمزانتقال وجه جدید"}
          type={"text"}
          isPassword={true}
          errors={errors.fixed_password}
        />

        <PaymentButton
          text={" ویرایش رمزانتقال وجه"}
          type={"submit"}
          isPending={isPending}
        />
      </form>
    </div>
  );
};

export default ChangeFixedPassPage;

// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

// import loaderGif from "../assets/gifs/loader.gif";
// import RequestConfig from "../mini_components/RequestConfig";
// import "react-toastify/dist/ReactToastify.css";
// import { Bounce, toast } from "react-toastify";
// import personWithIcon from "../assets/images/person-with-phone.png";
// import Loader from "../shared/Loader";

// function ChangeFixedPass() {
//   const [code, setCode] = useState("");
//   const [Pass, setPass] = useState("");
//   const [ConfirmPass, setConfirmPass] = useState("");
//   const [isCodeSent, setIsCodeSent] = useState(false);
//   const [OldPassword, setOldPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const verifyOtp = () => {
//     setLoading(true);
//     const raw = JSON.stringify({
//       otp: code,
//       fixed_password: Pass,
//     });
//     RequestConfig.post(`/users/fixed_password/otp/confirm/`, raw)
//       .then((response) => {
//         if (response.status === 200) {
//           setLoading(false);
//           toast.success("رمز انتقال وجه شما با موفقیت تغییر یافت .");
//           //Cookies.remove('token');
//           setIsCodeSent(true);
//           //navigate('/');
//         }
//       })
//       .catch((err) => {
//         //console.log(err);
//         setError(err);
//         setLoading(true);
//         const errorMessage = err.response?.data?.detail || err;
//         setIsCodeSent(false);
//         toast.error(`خطا: ${errorMessage}`, {
//           position: "bottom-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "dark",
//           transition: Bounce,
//         });
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };

//   const sendOtp = () => {
//     setLoading(true);

//     RequestConfig.post(`/users/fixed_password/otp/send/`)
//       .then((response) => {
//         if (response.status === 200) {
//           setLoading(false);
//           toast.success(" کد احراز هویت برای شما ارسال شد.");
//         } else {
//           setLoading(false);

//           toast.error(`خطا در ارسال کد احراز هویت`, {
//             position: "bottom-right",
//             autoClose: 5000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//             progress: undefined,
//             theme: "dark",
//             transition: Bounce,
//           });
//         }
//       })
//       .catch((err) => {
//         //console.log(err);
//         setError(err);

//         setLoading(false);
//         const errorMessage = err.response?.data?.detail || err;

//         toast.error(`خطا: ${errorMessage}`, {
//           position: "bottom-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "dark",
//           transition: Bounce,
//         });
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };
//   useEffect(() => {
//     sendOtp();
//   }, []);
//   return (
//     <div className=" p-4">
//       <div className="max-w-[90vw] w-fit min-w-[20vw] bg-white m-auto p-4 rounded-lg flex flex-col  gap-4">
//         <img src={personWithIcon} alt="" className=" max-h-[400px]"></img>

//         {loading && (
//           <div className="w-full h-full  min-h-[300px] flex items-center justify-center">
//             <Loader />
//           </div>
//         )}
//         {isCodeSent &&
//           <div className="w-full h-full  min-h-[300px] flex items-center justify-center">
//           <a href="/profile" className="text-[#FFFFFF] bg-[#39A78E] hover:bg-[#2A7A67] p-2 rounded mt-4 text-[20px] font-semibold w-fit mx-auto ">بازگشت به پروفایل</a>
//         </div>

//        }
//         {!loading && !isCodeSent && (
//           <>
//             <p>جهت تغییر رمز ثابت انتقال وجه فرم زیر را پر کنید</p>
//             <PasswordValidation/>
//             <form className="flex flex-col gap-4 w-full">
//               <input
//                 type="text"
//                 className="h-[52px] px-4 outline-none rounded-v-md w-full border-[1px] border-neutral-30 disabled:bg-neutral-10 disabled:border-none"
//                 placeholder="کد ارسال شده به تلفن همراه"
//                 aria-label="کد ارسال شده به تلفن همراه"
//                 onChange={(e) => setCode(e.target.value)}
//               />
//               <input
//                 type="text"
//                 className="h-[52px] px-4 outline-none rounded-v-md w-full border-[1px] border-neutral-30 disabled:bg-neutral-10 disabled:border-none"
//                 placeholder="رمز عبور جدید"
//                 aria-label="رمز عبور جدید"
//                 onChange={(e) => setPass(e.target.value)}
//               />
//               <input
//                 type="text"
//                 className="h-[52px] px-4 outline-none rounded-v-md w-full border-[1px] border-neutral-30 disabled:bg-neutral-10 disabled:border-none"
//                 placeholder="تکرار رمز عبور جدید"
//                 aria-label="تکرار رمز عبور جدید"
//                 onChange={(e) => setConfirmPass(e.target.value)}
//               />
//               <button
//                 onClick={verifyOtp}
//                 type="submit"
//                 className="text-[#FFFFFF] bg-[#39A78E] hover:bg-[#2A7A67] p-2 rounded mt-4 text-[20px] font-semibold w-fit mr-auto "
//               >
//                 ویرایش رمز انتقال وجه
//               </button>
//             </form>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }

// export default ChangeFixedPass;

// const PasswordValidation = () => {

//   const validationRules = [
//     "رمز عبور جدید می بایست حداقل 8 کاراکتر باشد",
//     "رمز عبور جدید می بایست حداکثر 20 کاراکتر باشد",
//     "رمز عبور جدید می بایست حداقل دارای یک حرف بزرگ انگلیسی باشد",
//     "رمز عبور جدید می بایست حداقل دارای یک حرف کوچک انگلیسی باشد",
//     "رمز عبور جدید می بایست حداقل دارای یک عدد باشد",
//     "رمز عبور جدید نمی تواند شامل حروف غیر انگلیسی باشد",
//     "رمز عبور جدید می بایست حداقل دارای یک کاراکتر خاص باشد",
//   ];

//   return (
//     <div className=" text-[11px]">
//       {validationRules.map((rule, index) => (
//         <div
//           key={index}
//          className="text-zinc-400 font-semibold "
//         >
//           {rule}
//         </div>
//       ))}
//     </div>
//   );
// };
